let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("9Gr3Q")).then(() => parcelRequire('9NAtJ'));